var _defs, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJumpsuit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 57.965,
    viewBox: "0 0 56 57.965",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.a{stroke:#4c4c4e;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.21 4.488)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28.249,19.281a11.185,11.185,0,0,1-12.14,0l-1.734-8.976c1.951-.449,1.734-7.18,1.734-7.18h1.734a4.154,4.154,0,0,0,4.336,3.59,4.154,4.154,0,0,0,4.336-3.59h1.734s-.217,6.732,1.734,7.18Z",
    transform: "translate(-12.641 -3.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28.733,14.375c1.986,2.962,3.469,7.18,3.469,9.873V46.687H25.265l-2.6-21.541-2.6,21.541H13.125V24.248c0-2.693,1.483-6.911,3.469-9.873",
    transform: "translate(-13.125 1.781)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28.328,22.068a6.27,6.27,0,0,1-5.2-2.693",
    transform: "translate(-9.251 3.961)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.125,22.068a6.27,6.27,0,0,0,5.2-2.693",
    transform: "translate(-13.125 3.961)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 56,
    height: 57.965
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJumpsuit);
export default __webpack_public_path__ + "static/media/Jumpsuit.5a6af9107462c74bc6b3045e27d6064d.svg";
export { ForwardRef as ReactComponent };